import Swiper from "swiper/bundle";

/**
 * Initializes and configures the product specifications component.
 */
export function productSpecsComponent() {

  // Select the swiper container element
  const productSpecsSwiperContainer = document.querySelector('.product-specs-swiper-container');

  if (!productSpecsSwiperContainer) {
    console.warn('Swiper container not found');
    return;
  }

   /**
   * Initializes a Swiper instance with the given selector and options.
   * @param {string} selector - The CSS selector for the Swiper container.
   * @param {Object} options - The configuration options for the Swiper instance.
   * @returns {Swiper} The initialized Swiper instance.
   */
   function initializeSwiper(selector, options) {
    return new Swiper(selector, options);
  }

  const swiperConfiguration = {
    slidesPerView: 1,
    direction: 'horizontal',
    spaceBetween: 16,
    loop: true,
    autoplay: {
      delay: 10000,
    },
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: 24,
      },
    },
    navigation: {
      prevEl: '.product-specs-pdp__swiper-prev',
      nextEl: '.product-specs-pdp__swiper-next',
    },
  };

  initializeSwiper('.product-specs-pdp__swiper', swiperConfiguration);
}
